// Short duration JWT token (5-10 min)
export function getJwtToken() {
  return window.localStorage.getItem("token")
    // return sessionStorage.getItem("jwt")
}

/**
 * Best-effort read of the current user's id from the JWT payload — the same
 * `userId` claim the BE signs and the socket handshake reads. Used only for
 * client-side echo-guarding of live `entity:section-updated` events (so a
 * user isn't told their OWN save is a remote change); it is NOT a security
 * check, so we read the payload without verifying the signature. Returns null
 * when there's no token or it can't be parsed.
 */
export function getCurrentUserId(): number | null {
    const token = getJwtToken();
    if (!token) return null;
    try {
        const part = token.split(".")[1];
        if (!part) return null;
        const base64 = part.replace(/-/g, "+").replace(/_/g, "/");
        const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
        const payload = JSON.parse(atob(padded));
        const id = payload?.userId;
        if (typeof id === "number") return id;
        return id != null && !Number.isNaN(Number(id)) ? Number(id) : null;
    } catch {
        return null;
    }
}

export function setJwtToken(token:string) {
    window.localStorage.setItem("token", token);
    //sessionStorage.setItem("jwt", token)
}

// Longer duration refresh token (30-60 min)
export function getRefreshToken() {
    // return sessionStorage.getItem("refreshToken")
    // Retrieve all cookies
  const cookies = document.cookie.split(';');

  // Find the refreshToken cookie
  const refreshTokenCookie = cookies.find(cookie => cookie.trim().startsWith('refreshToken='));

  // Extract and return the refreshToken value
  if (refreshTokenCookie) {
    return refreshTokenCookie.split('=')[1];
  }

  // Return null if refreshToken cookie is not found
  return null;
}

// export function setRefreshToken(token: string) {
//   // sessionStorage.setItem("refreshToken", token)
//   document.cookie = `refreshToken=${token}; path=/; secure; samesite=strict; secure=true`;
// }